import { render, staticRenderFns } from "./Precios.vue?vue&type=template&id=02eb961f"
import script from "./Precios.vue?vue&type=script&lang=js"
export * from "./Precios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports